import React from "react";

export function renderKarmingLogo() {
    return (
        <img
            height="34px"
            src="/static/images/karmingLogo.png"/>
    )
}
